export const groupsHeaders = [
  {
    text: 'Name',
    value: 'name',
    sortable: true,
    width: '25%',
  },
  {
    text: 'Description',
    value: 'description',
    sortable: true,
    width: '30%',
  },
  {
    text: 'Facilities Count',
    value: 'facilitiesCount',
    sortable: true,
    width: '15%',
  },
  {
    text: 'Created By',
    value: 'createdBy',
    sortable: true,
    width: '20%',
  },
  {
    text: 'Actions',
    value: 'actions',
    sortable: false,
    width: '10%',
    align: 'center',
  },
];
